<template>
  <FolderSelector class="folder-selector w100" v-model="destination" @change="handleChange" />
</template>

<script lang="ts" setup>import { Ref, ref } from 'vue';
import FolderSelector from '@/components/Bussiness/FolderSelector.vue'
const { modelValue } = defineProps<{
  modelValue: string
}>()

const emit = defineEmits(['update:modelValue', 'change'])
const destination: Ref<string> = ref('')

const handleChange = () => {
  emit('update:modelValue', destination.value)
  emit('change', destination.value)
}
</script>
<style lang="stylus" scoped>
.folder-selector{
  padding: 0;
  :deep(.content) {
    height: 200px;
    margin-top: 0;
  }
}

</style>